import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'
export const useStyles = makeStyles({
  '@global': {
    // '*::-webkit-scrollbar': {
    //   width: '0em'
    // },
    '*::-moz-scrollbar-track': {
      backgroundColor: 'red'
    },

    '& .css-3o0mcj-MuiTypography-root': {
      align: 'left !important ',
      fontSize: '14px !important'
    },
    '& .scroll_content': {
      // position: relative;
      width: '400px'
    }
  },
  leftBlock: {
    width: '100%',
    marginTop: '20px',
    gap: '16px',
    padding: '21px !important',
    [appTheme.breakpoints.up('lg')]: {
      padding: '21px 21px 0 80px !important'
    }
  },
  topNavBar: {
    // marginBottom: '60px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '58px',
    // flexDirection: 'row',
    [appTheme.breakpoints.up('lg')]: {
      padding: '21px 21px 0px 80px !important'
    },
    [appTheme.breakpoints.down('xl')]: {
      padding: '21px 21px 0px 21px !important',
      marginBottom: '48px'
    },
    [appTheme.breakpoints.down('lg')]: {
      padding: '21px 21px 0px 21px !important',
      marginBottom: '38px',
      gap: '16px'
    },
    [appTheme.breakpoints.down('md')]: {
      gap: '16px',
      marginBottom: '28px',
      marginTop: '11px'
    }
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    [appTheme.breakpoints.down('lg')]: {
      flexDirection: 'row'
    }
  },
  bigCalendar: {
    [appTheme.breakpoints.down('lg')]: {
      marginTop: '2rem'
    }
  },
  bigCalendarForMobile: {
    marginTop: '0rem',
    maxHeight: '100'
  },
  modalBox: {
    [appTheme.breakpoints.down('md')]: {
      top: `60px !important`,
      height: 'calc(100vh - 60px)'
    }
  },
  overflowWrapper: {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'inherit'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D9D9D9',
      borderRadius: '1.25rem'
    },
    '&::-moz-scrollbar-track': {
      backgroundColor: 'inherit'
    }
  },
  sticky: {
    // position: 'sticky',
    left: 0,
    background: '#006bd705'
  },
  tab: {
    '&.css-gh58gz-MuiButtonBase-root-MuiTab-root': {
      color: 'inherit'
    },
    '&.css-gh58gz-MuiButtonBase-root-MuiTab-root.Mui-selected ': {
      color: 'inherit'
    }
  }
})
